import React from 'react'
import Nav from './nav'
import Footer from './Footer'
import AdBanner from './AdBanner'
import NativeBanner from './NativeBanner'
export default function Disclaimer() {
  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#f8f9fa',
      fontFamily: 'Arial, sans-serif'
    },
    disclaimerSection: {
      flex: 1,
      maxWidth: '800px',
      margin: '40px auto',
      padding: '40px',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 2px 20px rgba(0,0,0,0.08)',
      lineHeight: '1.8',
      color: '#333'
    },
    heading: {
      textAlign: 'center',
      fontSize: '32px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '30px',
      paddingBottom: '20px',
      borderBottom: '3px solid #dc3545',
      position: 'relative'
    },
    headingUnderline: {
      position: 'absolute',
      bottom: '-3px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '50px',
      height: '3px',
      backgroundColor: '#dc3545'
    },
    subHeading: {
      fontSize: '22px',
      fontWeight: 'bold',
      color: '#dc3545',
      marginTop: '30px',
      marginBottom: '15px',
      paddingBottom: '10px',
      borderBottom: '2px solid #e9ecef'
    },
    paragraph: {
      fontSize: '16px',
      marginBottom: '15px',
      color: '#555',
      lineHeight: '1.8'
    },
    warningBox: {
      backgroundColor: '#fff3cd',
      padding: '20px 25px',
      borderRadius: '8px',
      margin: '20px 0',
      borderLeft: '5px solid #ffc107'
    },
    warningText: {
      margin: 0,
      color: '#856404',
      fontSize: '16px',
      fontWeight: '500'
    },
    infoBox: {
      backgroundColor: '#f8f9fa',
      padding: '20px 25px',
      borderRadius: '8px',
      margin: '20px 0',
      borderLeft: '5px solid #dc3545'
    },
    infoBoxText: {
      margin: 0,
      color: '#555',
      fontSize: '16px'
    },
    highlight: {
      color: '#dc3545',
      fontWeight: '600'
    },
    list: {
      listStyle: 'none',
      padding: '0',
      margin: '15px 0'
    },
    listItem: {
      padding: '10px 15px',
      marginBottom: '8px',
      backgroundColor: '#f8f9fa',
      borderRadius: '6px',
      borderLeft: '4px solid #dc3545',
      fontSize: '15px',
      color: '#555',
      transition: 'all 0.3s ease'
    },
    disclaimerBox: {
      backgroundColor: '#f8d7da',
      padding: '20px 25px',
      borderRadius: '8px',
      margin: '20px 0',
      borderLeft: '5px solid #dc3545'
    },
    disclaimerText: {
      margin: 0,
      color: '#721c24',
      fontSize: '18px',
      fontWeight: '600'
    },
    link: {
      color: '#dc3545',
      textDecoration: 'none',
      fontWeight: '600'
    },
    // Mobile Styles
    '@media (max-width: 768px)': {
      disclaimerSection: {
        margin: '20px 15px',
        padding: '25px 20px'
      },
      heading: {
        fontSize: '24px'
      },
      subHeading: {
        fontSize: '19px'
      },
      paragraph: {
        fontSize: '14px'
      },
      warningBox: {
        padding: '15px'
      },
      infoBox: {
        padding: '15px'
      },
      disclaimerBox: {
        padding: '15px'
      },
      warningText: {
        fontSize: '14px'
      },
      infoBoxText: {
        fontSize: '14px'
      },
      disclaimerText: {
        fontSize: '16px'
      },
      listItem: {
        fontSize: '14px',
        padding: '8px 12px'
      }
    },
    '@media (max-width: 480px)': {
      disclaimerSection: {
        margin: '15px 10px',
        padding: '20px 15px'
      },
      heading: {
        fontSize: '20px'
      },
      subHeading: {
        fontSize: '17px'
      },
      disclaimerText: {
        fontSize: '14px'
      }
    }
  }

  return (
    <div style={styles.container}>
      <Nav />
              <AdBanner />
      <div style={styles.disclaimerSection}>
        <h1 style={styles.heading}>
          ⚠️ Disclaimer
          <span style={styles.headingUnderline}></span>
        </h1>

        <div style={styles.warningBox}>
          <p style={styles.warningText}>
            📌 Please read this disclaimer carefully before using our website.
          </p>
        </div>

        <p style={styles.paragraph}>
          The information provided on this website is for general informational purposes only.
          While we strive to keep the content accurate and up to date, we make no warranties
          regarding its completeness, accuracy, or reliability.
        </p>
    
                <NativeBanner />
        <h2 style={styles.subHeading}>
          📖 Use of the Website
        </h2>

        <div style={styles.infoBox}>
          <p style={styles.infoBoxText}>
            By accessing and using this website, you agree that you do so at your own risk.
          </p>
        </div>

        <p style={styles.paragraph}>
          We are not responsible for any loss or damage resulting from the use of this website
          or the mobile application available for download.
        </p>
      
        <h2 style={styles.subHeading}>
          📲 Application Downloads
        </h2>

        <ul style={styles.list}>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            Our website provides access to download our mobile application.
          </li>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            We encourage users to download the <strong>latest official version</strong> only.
          </li>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            We are not responsible for issues caused by modified or unofficial versions of the application.
          </li>
        </ul>

        <h2 style={styles.subHeading}>
          🔗 External Links
        </h2>

        <p style={styles.paragraph}>
          This website may contain links to third-party websites for your convenience.
          We do not control or endorse the content, services, or policies of those websites
          and are not responsible for any damages arising from their use.
        </p>

        <h2 style={styles.subHeading}>
          🛡️ No Warranty
        </h2>

        <div style={styles.disclaimerBox}>
          <p style={styles.disclaimerText}>
            All information, services, and downloads are provided on an <strong>"AS IS"</strong> and
            <strong>"AS AVAILABLE"</strong> basis without any express or implied warranties.
          </p>
        </div>

        <h2 style={styles.subHeading}>
          📝 Changes to This Disclaimer
        </h2>

        <p style={styles.paragraph}>
          We reserve the right to update or modify this Disclaimer at any time without prior
          notice. Continued use of the website after changes have been posted constitutes
          your acceptance of the updated Disclaimer.
        </p>

        <h2 style={styles.subHeading}>
          📧 Contact Us
        </h2>

        <div style={{...styles.infoBox, borderLeftColor: '#007bff'}}>
          <p style={styles.infoBoxText}>
            If you have any questions regarding this Disclaimer, please <a 
              href="/contact" 
              style={{
                color: '#007bff',
                textDecoration: 'none',
                fontWeight: '600'
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = 'underline'
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = 'none'
              }}
            >
              contact us
            </a> through the Contact page.
          </p>
        </div>

        <div style={{
          textAlign: 'center',
          marginTop: '30px',
          padding: '15px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          fontSize: '14px',
          color: '#888'
        }}>
          <p style={{margin: 0}}>
            ⚡ <strong style={styles.highlight}>APKNU.com</strong> - All rights reserved. Use at your own risk.
          </p>
        </div>
      </div>
              <AdBanner />
      <Footer />
    </div>
  )
}